(function($, Cobalt, undefined) {
    var hideNavigationWidget = false;

    Cobalt.TemplateAndSkin = {
        skinMap: '',
        initalTemplateID: '',
        initialSkinID: '',
        siteID: null,
        initialize: function(skinMap, initialTemplateID, initialSkinID, siteID) {
            Cobalt.TemplateAndSkin.skinMap = skinMap;
            Cobalt.TemplateAndSkin.initalTemplateID = initialTemplateID;
            Cobalt.TemplateAndSkin.initialSkinID = initialSkinID;
            Cobalt.TemplateAndSkin.siteID = siteID;

            if (initialTemplateID != null) {
                Cobalt.TemplateAndSkin.selectTemplate(initialTemplateID);
            }
            else {
                var templateLi = $("li[data-template-id]")[0];
                if ($(templateLi) != undefined && $(templateLi).length > 0) {
                    Cobalt.TemplateAndSkin.selectTemplate($(templateLi).attr("data-template-id"));
                }
            }

            if (initialSkinID != null) {
                if (Cobalt.TemplateAndSkin.skinMap[initialTemplateID] != undefined) {
                    var selectedSkinArray = $.grep(Cobalt.TemplateAndSkin.skinMap[initialTemplateID], function(skin) {
                        return (skin.id == initialSkinID);
                    });
                    var selectedSkin = selectedSkinArray[0];
                    if (selectedSkin != null) {
                        Cobalt.TemplateAndSkin.selectSkin(selectedSkin.id, selectedSkin, selectedSkin.previewUrl);
                    }
                }
            } else {
                $("img#preview").attr("src", Cobalt.TemplateAndSkin.noPreview);
            }
            $(".template-selector").click(function(event) {
                var index = parseInt($(this).attr("data-index"));
                Cobalt.TemplateAndSkin.selectTemplate(index);
                var selectedSkin = selectedSkinArray[index];
                if (selectedSkin != null) {
                    Cobalt.TemplateAndSkin.selectSkin(selectedSkin.id, selectedSkin, selectedSkin.previewUrl);
                }

                event.preventDefault();
            });


            var li = $("li[data-template-id]");
            li.each(function() {
                var that = this;
                $(that).tooltip({
                    'content': $(that).attr("data-qtip")
                });
            });
        },
        noPreview: "/Content/Skins/Global/images/skin-preview.jpg",
        selectTemplate: function(tempId) {
            $("#Template").val(tempId);
            $("#Skin").val("");
            var templateName = $(".template-selector[data-index=" + tempId + "]").text();
            $("ul#template-selection li").removeClass("selected");
            var $li = $("li[data-template-id='" + tempId + "']");
            $li.addClass("selected");
            $("#selectedTemplateName").html(templateName);
            $("#skin-selection, #skin-selection-detailed").empty();

            hideNavigationWidget = $li.attr("data-is-topnav") === "true";
            if (hideNavigationWidget) {
                $("#widget-area-navigation").hide();
            } else {
                $("#widget-area-navigation").show().addClass("widget-widget-locked");
            }

            Cobalt.TemplateAndSkin.selectSkin("", null, Cobalt.TemplateAndSkin.noPreview);
            if (Cobalt.TemplateAndSkin.skinMap[tempId] != undefined) {
                $.each(Cobalt.TemplateAndSkin.skinMap[tempId], function() {
                    var data = this;
                    var isDisabled = data != null && (data.cssClass.search("disabled") > -1);
                    var ul = $("ul#skin-selection-detailed");
                    $(ul).append($("<li>").addClass(data.cssClass)
                    .attr("data-skin-id", data.id)
                    .attr("data-qtip", "<img src=\"" + data.previewUrl + "\" />")
                    .append(function() {
                        if (!isDisabled) {
                            return $("<a>")
                            .attr("href", "#")
                            .append($("<img>").attr("src", data.previewSmallUrl))
                            .click(function(event) {
                                Cobalt.TemplateAndSkin.selectSkin(data.id, data, data.previewUrl);
                                event.preventDefault();
                            });
                        }
                        else {
                            return $("<img>").attr("src", data.previewSmallUrl);
                        }
                    })
                    .append($("<div>")
                        .addClass("skin-caption")
                        .append(function() {
                            var skinName = $("<a>").attr("href", "#")
                                    .append(data.name);
                            if (!isDisabled) {
                                skinName = skinName
                                    .click(function(event) {
                                        Cobalt.TemplateAndSkin.selectSkin(data.id, data, data.previewUrl);
                                        event.preventDefault();
                                    });
                            }
                            return skinName;
                        })
                        )
                    );

                    var li = $("li[data-skin-id='" + data.id + "']")
                    $(li).tooltip({
                        'content': $(li).attr("data-qtip")
                    });
                });
            }
            var firstSkin = $("li[data-skin-id]")[0];
            if (firstSkin) {
                var skinID = $(firstSkin).attr("data-skin-id");
                var data;
                $(Cobalt.TemplateAndSkin.skinMap[tempId]).each(function(i, val) {
                    if (val.id == skinID) {
                        data = val;
                    }
                });
                Cobalt.TemplateAndSkin.selectSkin(skinID, data, data.previewUrl);
            }
            Cobalt.Widget.getWidgetSelector(tempId, Cobalt.TemplateAndSkin.siteID, function() {
                if (hideNavigationWidget) {
                    $("#widget-area-navigation").hide();
                } else {
                    $("#widget-area-navigation").show().addClass("widget-widget-locked");
                }
            });
        },
        selectSkin: function(skinId, skinData, previewUrl) {
            var skinName = "--";
            if (skinData != null) {
                skinName = skinData.Name;
            }
            $("#Skin").val(skinId);

            var skinElement = $("ul#skin-selection li, ul#skin-selection-detailed li");
            skinElement.removeClass("selected");

            if (skinId != "") {
                $("li[data-skin-id='" + skinId + "']").addClass("selected");
            }
            $("#selectedSkinName").html(skinName);
            $("fieldset#selected img#preview").attr("src", previewUrl);
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.TemplateAndSkin.js